import React from 'react';

import Responsive from '@/components/Responsive';

import { StaticFilterProps } from '../types';
import StaticFilterDesktop from './index.desktop';
import StaticFilterMobile from './index.mobile';

const StaticFilter = (props: StaticFilterProps) => {
  return (
    <Responsive>
      <Responsive.Default>
        <StaticFilterDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <StaticFilterMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
};

export default StaticFilter;
